module.exports = __webpack_public_path__ + "img/WP2023-Presenter-1200-630.26188711.png";